import { _ as _objectSpread2, b as _objectWithoutProperties } from '../../_rollupPluginBabelHelpers-fb970440.js';
import { makeVar } from '@apollo/client';

var _excluded = ["proposerDetails", "proposerDetailsMeta"];
var init_state = {
  businessType: '',
  businessTypeValue: '',
  customerFetchRequiredOnLoad: false,
  productType: '',
  productTypeValue: '',
  intermediaryDetails: {
    code: '',
    intermediaryName: '',
    location: '',
    branchOfficeName: '',
    fieldUserCode: '',
    fieldUserName: ''
  },
  isQuoteSaved: false,
  quoteData: null,
  coverData: null,
  quoteNumber: '',
  quoteStatus: '',
  quoteCreationDate: '',
  proposalNumber: '',
  proposalStatus: '',
  productCode: '',
  isProposalApplicableForPayment: null,
  isPolicyIssued: false,
  existingPolicyNumber: '',
  isExistingEmployee: '',
  isTrailerRequired: false,
  nooftrailers: '',
  towedby: '',
  QuotationRecordNo: '',
  coverforlamps: false,
  coverforprivateandcommercial: false,
  vehicleusedlimitedtoownpremises: false,
  vehicleuseddrivingtuitions: false,
  ImportedVehicle: false,
  ConfinedtoOwnPremises: false,
  SoftCopyDiscount: false,
  AntiTheftDiscount: false,
  disableNCB: false,
  proposerDetailsMeta: {
    crn: '',
    isNewCustomer: null,
    ifscCode: '',
    bankName: '',
    branchName: '',
    bankAcno: '',
    accountHolderName: '',
    micrCode: ''
  },
  proposerDetails: {
    id: '',
    customerType: '',
    title: '',
    gender: '',
    firstName: '',
    middleName: '',
    lastName: '',
    fullName: '',
    occupation: '',
    maritalStatus: '',
    nationality: '',
    proposerDOB: '',
    panNumber: '',
    idProofType: '',
    idProofNumber: '',
    permAddressLine1: '',
    permAddressLine2: '',
    permAddressLine3: '',
    permLandmark: '',
    permPincode: '',
    permCityTownVillage: '',
    permDistrict: '',
    permState: '',
    permCommAddressYN: false,
    commAddressLine1: '',
    commAddressLine2: '',
    commAddressLine3: '',
    commLandmark: '',
    commPincode: '',
    commCityTownVillage: '',
    commDistrict: '',
    commState: '',
    mobileNo: '',
    emailID: '',
    orgName: '',
    orgType: '',
    contactName: '',
    regNumber: '',
    tanNumber: '',
    gstNumber: '',
    phoneNo: '',
    altPhoneNo: '',
    altMobileNo: '',
    faxNo: '',
    employeeNumber: '',
    motherMaidenName: '',
    eiaRequired: 'No',
    eiaNumber: '',
    ckycIdNumber: '',
    certificateOfInCorporation: '',
    udyogAadhaarNumber: ''
  },
  vehicleTabDetails: {
    vehicleRegistrationDetails: {
      registrationNumber: '',
      registrationNumberParts: {
        part1: '',
        part2: '',
        part3: '',
        part4: '',
        bhseries: ''
      },
      isNewVehicle: false,
      engineNumber: '',
      chasisNumber: ''
    },
    vehicleDetails: {
      make: {
        code: '',
        value: ''
      },
      model: {
        code: '',
        value: ''
      },
      variant: {
        code: '',
        value: ''
      },
      carriageType: {
        code: '',
        value: ''
      },
      permitType: {
        code: '',
        value: ''
      },
      usageType: {
        code: '',
        value: ''
      },
      typeofCarriage: {
        code: '',
        value: ''
      },
      typeOfBody: '',
      vehicleuse: {
        code: '',
        value: ''
      },
      typeOfMiscVehicle: {
        code: '',
        value: ''
      },
      natureofgoods: {
        code: '',
        value: ''
      },
      vehiclesubType: {
        code: '',
        value: ''
      },
      fuelType: '',
      cubeCapacity: '',
      seatingCapacity: '',
      yearOfManufacture: '',
      carryingCapacity: '',
      gvw: '',
      rtoDetails: {
        rtoAuthorityCode: '',
        rtoLocationCode: '',
        rtoLocationDesc: ''
      },
      dateOfRegistration: ''
    },
    insuredDeclaredDetails: {
      vehicleIDV: null,
      irfAdjustmentPercent: ''
    }
  },
  additionalTabDetails: {
    previousInsuranceAndClaims: {
      previousPolicyDetails: {
        previousInsurerName: '',
        expiringPolicyNumber: '',
        policyCoverType: '',
        policyStartDate: '',
        policyExpiryDate: '',
        policyTenure: '',
        policyTenureValue: ''
      },
      previousClaims: {
        totalClaimCount: '',
        totalClaimCountValue: '',
        totalClaimAmount: '',
        previousYearNCBSlab: '',
        noOfClaimsYear1: '',
        noOfClaimsYear2: '',
        noOfClaimsYear3: ''
      }
    },
    nomineeDetails: {
      nomineeName: '',
      nomineeDob: '',
      relationshipWithNominee: '',
      nameOfAppointee: '',
      relationshipWithAppointee: ''
    },
    financeDetails: {
      vehicleOwned: '',
      financerDetails: {
        financerName: '',
        financerAddress: '',
        financerAgreementType: '',
        loanAccountNumber: '',
        fileNumber: ''
      }
    },
    trailerDetails: []
  },
  reviewAndConfirmTabDetails: {
    proposalPaymentType: '',
    leadGenerator: '',
    isProposalCreated: false
  },
  policy: {
    startDate: '',
    endDate: '',
    time: ''
  },
  issuedPolicyData: {
    policyNo: '',
    receiptID: [],
    referenceNumber: '',
    digiLink: '',
    displayMessage: '',
    additionalMessage: ''
  },
  premiumData: {
    idv1: '',
    idv2: '',
    idv3: '',
    tenure: '',
    netODPremium: null,
    netTPPremium: null,
    loadingDiscount: null,
    netPremium: null,
    gst: null,
    stampDuty: null,
    totalPremium: null,
    loading: [],
    discount: [],
    vehicleAge: '',
    claimFreeYear: '',
    creditScore: ''
  } //SA975
  || {
    baseod_premium: '',
    basetppremium: '',
    ncbamount: '',
    ncbpercentage: '',
    odpremium: '',
    pacoveramount: '',
    paiddriverlegalliability: '',
    gst: '',
    premium: '',
    finalpremium: '',
    otherdiscount: '',
    addonprice: '',
    packageprice: '',
    transactionid: '',
    requestid: '',
    idv: '',
    policy_start_date: '',
    policy_end_date: '',
    depreciation_prem: '',
    consumable_prem: '',
    engineprotect_prem: '',
    rti_prem: '',
    rsa_prem: '',
    ncb_protect_prem: '',
    key_replacement_prem: '',
    daily_car_allowance_prem: '',
    tyre_prem: '',
    loss_of_pnbll_prem: '',
    imt28_prem: '',
    pa_unnamed_premium: '',
    vddiscount_amt: '',
    garage_cash_prem: '',
    tppd_restriction_amt: '',
    commercial_private: '',
    net_tp_premiun: '',
    electrical_prem: '',
    non_electrical_prem: '',
    cng_od_prem: '',
    cng_tp_prem: '',
    trailer_od_prem: '',
    trailer_tp_prem: '',
    geo_od_prem: '',
    geo_tp_prem: '',
    rally_od_prem: '',
    rally_tp_prem: '',
    addnl_owner_driver_prem: '',
    addnl_passenger_prem: '',
    addnl_towing_prem: '',
    hospital_prem: '',
    emergency_prem: '',
    emi_prem: '',
    courtesy_prem: '',
    pa_to_unnamed_prem: '',
    pa_to_named_prem: '',
    pa_to_paid_driver_prem: '',
    pa_to_no_of_soldier_prem: '',
    imt29_prem: '',
    softcopy_amount: '',
    fibre_glass_amount: '',
    anti_theft_amount: '',
    vintage_amount: '',
    imported_vehicle_amount: '',
    driving_tution_amount: '',
    vehicle_used_blind_amount: '',
    own_premices_amount: '',
    automobile_amount: '',
    kotak_emp_amount: '',
    voluntary_ductible_dep_amount: '',
    fuel_nonconventional_dicount: '',
    imt18_premium: '',
    loss_of_access: '',
    campaign_code: '',
    basic_glm_rate: '',
    dep_glm_rate: '',
    consumable_glm_rate: '',
    rti_glm_rate: '',
    engprot_glm_rate: '',
    tyre_glm_rate: '',
    lop_glm_rate: '',
    daily_car_glm_rate: '',
    ncb_prot_glm_rate: '',
    adnl_od_glm_rate: '',
    adnl_pass_glm_rate: '',
    hospital_glm_rate: '',
    emergency_glm_rate: '',
    emi_glm_rate: '',
    key_glm_rate: '',
    adnl_tow_glm_rate: '',
    garage_glm_rate: '',
    courtesy_glm_rate: '',
    switchcover_premium: '',
    switchdisc_rate: '',
    switchdisc_amt: '',
    idv2: '',
    idv3: '',
    vehicle_age: '',
    system_idv: '',
    errorcode: '',
    success: '',
    errormessage: ''
  },
  //EA975
  premiumDetails: {
    termsAndConditions: false,
    paymentMethod: '',
    payerType: '',
    onlinePayment: {
      transactionId: '',
      isTransactionIdVerified: null
    },
    cdWallet: {
      cdAccountNo: '',
      cdAccountBalance: ''
    },
    cheque: [],
    demandDraft: []
  }
};
var buyMotorPolicyVar = makeVar(init_state);
var initBuyMotorPolicyVar = function initBuyMotorPolicyVar() {
  buyMotorPolicyVar(init_state);
};
var resetProposerDetails = function resetProposerDetails(data) {
  var initObj = {},
      initMetaObj = {};
  Object.keys(buyMotorPolicyVar().proposerDetails).forEach(function (v) {
    if (data !== null && data !== void 0 && data.proposerDetails[v]) {
      initObj[v] = data.proposerDetails[v];
    } else {
      if (v === 'permCommAddressYN') {
        initObj[v] = false;
      } else {
        initObj[v] = '';
      }
    }
  });
  Object.keys(buyMotorPolicyVar().proposerDetailsMeta).forEach(function (v) {
    if (data !== null && data !== void 0 && data.proposerDetailsMeta[v]) {
      initMetaObj[v] = data.proposerDetailsMeta[v];
    } else {
      initMetaObj[v] = '';
    }
  });
  buyMotorPolicyVar(_objectSpread2(_objectSpread2({}, buyMotorPolicyVar()), {}, {
    proposerDetails: initObj,
    proposerDetailsMeta: initMetaObj
  }));
};
var updateBuyMotorPolicy = function updateBuyMotorPolicy(data) {
  var proposerDetails = data.proposerDetails,
      proposerDetailsMeta = data.proposerDetailsMeta,
      rest = _objectWithoutProperties(data, _excluded);

  if (proposerDetails && proposerDetailsMeta) {
    buyMotorPolicyVar(_objectSpread2(_objectSpread2({}, buyMotorPolicyVar()), {}, {
      proposerDetails: _objectSpread2(_objectSpread2({}, buyMotorPolicyVar().proposerDetails), proposerDetails),
      proposerDetailsMeta: _objectSpread2(_objectSpread2({}, buyMotorPolicyVar().proposerDetailsMeta), proposerDetailsMeta)
    }, rest));
  } else if (proposerDetails && !proposerDetailsMeta) {
    buyMotorPolicyVar(_objectSpread2(_objectSpread2({}, buyMotorPolicyVar()), {}, {
      proposerDetails: _objectSpread2(_objectSpread2({}, buyMotorPolicyVar().proposerDetails), proposerDetails)
    }, rest));
  } else if (!proposerDetails && proposerDetailsMeta) {
    buyMotorPolicyVar(_objectSpread2(_objectSpread2({}, buyMotorPolicyVar()), {}, {
      proposerDetailsMeta: _objectSpread2(_objectSpread2({}, buyMotorPolicyVar().proposerDetailsMeta), proposerDetails)
    }, rest));
  } else {
    buyMotorPolicyVar(_objectSpread2(_objectSpread2({}, buyMotorPolicyVar()), rest));
  }
};
var updatePaymentMethod = function updatePaymentMethod(data) {
  return buyMotorPolicyVar(_objectSpread2(_objectSpread2({}, buyMotorPolicyVar()), data));
};
var updateCheque = function updateCheque(data) {
  return buyMotorPolicyVar(_objectSpread2(_objectSpread2({}, buyMotorPolicyVar()), {}, {
    cheque: data
  }));
};

export { buyMotorPolicyVar, initBuyMotorPolicyVar, resetProposerDetails, updateBuyMotorPolicy, updateCheque, updatePaymentMethod };
